document.addEventListener("DOMContentLoaded", () => {
  const allSelects = document.querySelectorAll("[data-fake-select]");

  function closeAll(except = null) {
    allSelects.forEach(s => {
      if (s !== except) s.classList.remove("is-open");
    });
  }

  function setSelected(select, optionEl) {
    const trigger = select.querySelector("[data-fake-trigger]");
    const input = select.querySelector("[data-selected-variant]");

    // Update hidden input (Shopify variant id)
    input.value = optionEl.dataset.variantId;

    // Make the button identical to the option
    // data-option-html is escaped -> we can safely inject as HTML
    trigger.innerHTML = optionEl.dataset.optionHtml;
  }

  allSelects.forEach(select => {
    const trigger = select.querySelector("[data-fake-trigger]");
    const dropdown = select.querySelector("[data-fake-dropdown]");
    const input = select.querySelector("[data-selected-variant]");
    const addBtn = select.querySelector(".custom-quick-add__button");
    const options = Array.from(select.querySelectorAll(".fake-select__option"));

    // Mark disabled
    options.forEach(opt => {
      if (opt.dataset.available !== "true") opt.classList.add("is-disabled");
    });

    // Default = first available
    const firstAvailable = options.find(o => o.dataset.available === "true") || options[0];
    if (firstAvailable) setSelected(select, firstAvailable);

    // Open / close
    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      const willOpen = !select.classList.contains("is-open");
      closeAll(select);
      select.classList.toggle("is-open", willOpen);
    });

    // Select option
    options.forEach(option => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        if (option.dataset.available !== "true") return;

        setSelected(select, option);
        select.classList.remove("is-open");
      });
    });

    // Close on outside click
    document.addEventListener("click", () => {
      select.classList.remove("is-open");
    });

    // Add to cart (selected variant)
    addBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      const variantId = input.value;
      if (!variantId) return;

      addBtn.classList.add("loading");
      addBtn.setAttribute("aria-disabled", "true");
      addBtn.disabled = true;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!res.ok) throw new Error("Cart add failed");
        const data = await res.json();

        // Optionnel: déclencher un event pour que ton thème ouvre le drawer / update le compteur
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { added: data } }));
        // Si ton thème écoute l’event Shopify standard:
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { added: data } }));

      } catch (err) {
        console.error(err);
        // Optionnel: afficher un message
        alert("Impossible d'ajouter au panier. Réessaie.");
      } finally {
        addBtn.classList.remove("loading");
        addBtn.removeAttribute("aria-disabled");
        addBtn.disabled = false;
        window.location.reload();
      }
    });
  });
});
